import React, { useState, createContext, useContext } from 'react';
import { cn } from '../../lib/utils';

const SelectContext = createContext();

export const Select = ({ value, onValueChange, children, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value);
  
  const handleSelect = (val) => {
    setSelectedValue(val);
    if (onValueChange) onValueChange(val);
    setIsOpen(false);
  };

  return (
    <SelectContext.Provider value={{ selectedValue, onSelect: handleSelect, isOpen, setIsOpen }}>
      <div className="relative" {...props}>{children}</div>
    </SelectContext.Provider>
  );
};

export const SelectTrigger = ({ className, children, ...props }) => {
  const { isOpen, setIsOpen } = useContext(SelectContext);
  return (
    <button
      className={cn(
        "flex h-10 w-full items-center justify-between rounded-md border border-slate-200 bg-white px-3 py-2 text-sm ring-offset-white placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500",
        className
      )}
      onClick={() => setIsOpen(!isOpen)}
      {...props}
    >
      {children}
    </button>
  );
};

export const SelectValue = ({ placeholder, ...props }) => {
  const { selectedValue } = useContext(SelectContext);
  return <span {...props}>{selectedValue || placeholder}</span>;
};

export const SelectContent = ({ children, className, ...props }) => {
  const { isOpen } = useContext(SelectContext);
  if (!isOpen) return null;
  return (
    <div className={cn(
      "absolute z-50 min-w-[8rem] overflow-hidden rounded-md border border-slate-200 bg-white p-1 shadow-md",
      "top-full left-0 mt-1",
      className
    )} {...props}>
      {children}
    </div>
  );
};

export const SelectItem = ({ value, children, className, ...props }) => {
  const { selectedValue, onSelect } = useContext(SelectContext);
  const isSelected = selectedValue === value;
  return (
    <div
      className={cn(
        "relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors hover:bg-slate-100",
        isSelected && "bg-indigo-50 text-indigo-700",
        className
      )}
      onClick={() => onSelect(value)}
      {...props}
    >
      {children}
    </div>
  );
};
